import React from 'react';

const LoadingText = (props) => {
  return <div className="dashboard-loading text-sm text-neutral-600">Loading...</div>
}

export default LoadingText;
